const BREAK_POINT = 768

document.addEventListener('DOMContentLoaded', () => {
  const footerAccordionTriggers = document.querySelectorAll('.js-footer-accordion-trigger')

  // メディアクエリ設定
  const mediaQuery = window.matchMedia(`(min-width: ${BREAK_POINT}px)`)
  handleMediaQueryChange(mediaQuery, footerAccordionTriggers) // 初回実行

  // メディアクエリの変更を監視
  mediaQuery.addEventListener('change', () => handleMediaQueryChange(mediaQuery, footerAccordionTriggers))
})

// ブレイクポイントをまたぐ際の処理
const handleMediaQueryChange = (mediaQuery, footerAccordionTriggers) => {
  if (mediaQuery.matches) {
    setupDesktopFooter(footerAccordionTriggers)
  } else {
    setupMobileFooter(footerAccordionTriggers)
  }
}

const setupMobileFooter = (triggers) => {
  triggers.forEach((trigger) => {
    trigger.setAttribute('role', 'button')
    trigger.setAttribute('tabindex', '0')

    // イベントリスナーを登録
    manageEventListeners(trigger, true)
  })
}

const setupDesktopFooter = (triggers) => {
  triggers.forEach((trigger) => {
    trigger.removeAttribute('role')
    trigger.removeAttribute('tabindex')
    trigger.removeAttribute('aria-expanded')
    trigger.classList.remove('is-open')

    // イベントリスナーを解除
    manageEventListeners(trigger, false)
  })
}

// イベントリスナーを登録または解除
const manageEventListeners = (element, shouldAdd) => {
  const method = shouldAdd ? 'addEventListener' : 'removeEventListener'
  element[method]('click', handleAccordionClick)
  element[method]('keyup', handleAccordionKeyup)
}

// アコーディオンの開閉
const toggleAccordion = (trigger) => {
  const isOpen = trigger.classList.toggle('is-open')
  trigger.setAttribute('aria-expanded', isOpen)
}

// クリックイベント
const handleAccordionClick = (event) => {
  event.stopPropagation()
  toggleAccordion(event.currentTarget)
}

// キーボードイベント
const handleAccordionKeyup = (event) => {
  if (event.key === 'Enter') toggleAccordion(event.currentTarget)
}
